import { render, staticRenderFns } from "./PropertiesTable.vue?vue&type=template&id=6d5b5153&scoped=true&"
import script from "./PropertiesTable.vue?vue&type=script&lang=js&"
export * from "./PropertiesTable.vue?vue&type=script&lang=js&"
import style0 from "./PropertiesTable.vue?vue&type=style&index=0&id=6d5b5153&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5b5153",
  null
  
)

export default component.exports